import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Spin,
  Switch,
  message,
} from 'antd';
import {
  deleteSVG,
  editSVG,
  addSVG,
  salonSVG,
  noticeSVG,
} from '../../assets/settings/SVGs';
import { getPromoCodes, deletePromoCodes } from '../../network/settings';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import queryClient from '../../services/react-query/queryClient';
import { useIntl } from 'react-intl';
import DiscountCodeModal from '../../components/settings/modal/DiscountCodeModal';
import { queryKeys } from '../../services/react-query/queryKeys';

type Props = {};

const DiscountCodes = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState<any>();
  const navigate = useNavigate();
  const intl = useIntl();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsEditModalOpen(false);
    setIsModalOpen(false);
  };

  const showEditModal = (body: any) => {
    setIsEditModalOpen(body);
    setIsModalOpen(true);
  };

  const [form] = Form.useForm();
  const { data: promoCodes, isLoading } = useQuery(
    [queryKeys?.promoCodes],
    () => getPromoCodes()
  );
  const { mutate: deletePromo } = useMutation(deletePromoCodes, {
    onSuccess: (res: any) => {
      if (
        res?.response?.status === 422 ||
        res?.response?.status === 500 ||
        res?.response?.status === 404
      ) {
        message.error(res?.response?.data?.message);
      } else {
        message.success(' Promo Code Deleted');
        queryClient.invalidateQueries([queryKeys.promoCodes]);
      }
    },
  });

  return (
    <>
      <Modal
        width={'50%'}
        destroyOnClose
        open={isModalOpen}
        onCancel={handleCancel}
        className="max-md:!w-[95%] max-xl:!w-[75%]"
        footer={null}
      >
        <DiscountCodeModal close={handleCancel} data={isEditModalOpen} />
      </Modal>

      <div className="text-color-primary text-2xl font-semibold leading-7 flex items-center gap-2 text-end">
        {intl.formatMessage({ id: 'discountCodes.settingsTitle' })}
      </div>
      <div className="my-4 text-color-gray text-base font-normal leading-7 ">
        {intl.formatMessage({ id: 'discountCodes.description' })}
      </div>
      <Spin spinning={isLoading}>
        <Form form={form}>
          <div className="bg-[#EEF0FF] px-4 py-6 rounded-lg Taxes">
            <div className="bg-white p-4 rounded-lg w-full">
              <div className="flex flex-col items-center justify-between">
                <span className="text-color-primary text-sm mb-4 w-full">
                  {intl.formatMessage({ id: 'availableValues' })} :
                </span>
                <div className="flex items-center justify-between w-full">
                  <div className="flex max-lg:flex-col text-sm items-center justify-between gap-4 my-auto">
                    {isLoading ||
                      promoCodes?.data.map((promoCode: any) => (
                        <div
                          key={promoCode.id}
                          className="flex items-center justify-between gap-4 py-[8px] px-[10px] border-color-primary border-solid border-[1px] rounded-lg bg-[#FBFBFF]"
                        >
                          <div className="flex items-center gap-2">
                            <span
                              dir="ltr"
                              className="border-color-success border-[1px] px-[6px] py-[8px] rounded-lg border-solid text-color-success"
                            >
                              {promoCode.value}
                              {promoCode.value_type === 'price' ? '' : '%'}
                            </span>
                            <span className="text-center font-semibold text-[#020418]">
                              {promoCode.code}
                            </span>
                          </div>
                          <div className="flex items-center gap-2">
                            <span
                              onClick={() => showEditModal(promoCode)}
                              className="flex items-center cursor-pointer"
                            >
                              {editSVG}
                            </span>
                            <span
                              onClick={() => deletePromo(promoCode.id)}
                              className="flex items-center cursor-pointer"
                            >
                              {deleteSVG}
                            </span>
                          </div>
                        </div>
                      ))}
                  </div>
                  <Button
                    type="primary"
                    className="flex items-center gap-2 lg:my-auto self-start font-semibold"
                    onClick={showModal}
                  >
                    {addSVG}{' '}
                    {intl.formatMessage({ id: 'discountCodes.newCodeButton' })}
                  </Button>
                </div>
              </div>
              {/* <Divider className="my-4" /> */}
              {/* <div className="w-full flex items-center flex-col gap-1 max-lg:mt-2">
              <div className="flex items-center justify-between w-full">
                <div className="text-base max-md:text-sm font-semibold mb-2">
                  {intl.formatMessage({
                    id: "discountCodes.activateDiscountCodes",
                  })}
                </div>
                <Switch />
              </div>
              <p className="text-[#9999A7] w-full text-xs max-md:text-[10px] flex items-center gap-2">
                {noticeSVG}{" "}
                {intl.formatMessage({ id: "discountCodes.activationNotice" })}
              </p>
            </div> */}
            </div>
          </div>
          {/* <div className="flex items-end justify-end text-left gap-4 w-full my-4 mt-8">
            <Button
              type="primary"
              htmlType="submit"
              className="w-fit min-w-[150px] max-w-[150px]"
            >
              {intl.formatMessage({ id: 'saveChanges' })}
            </Button>

            <Button
              type="primary"
              className="btn-primary-not w-fit max-w-[150px] min-w-[150px]"
              onClick={() => navigate(-1)}
            >
              {intl.formatMessage({ id: 'cancel' })}
            </Button>
          </div> */}
        </Form>
      </Spin>
    </>
  );
};

export default DiscountCodes;
